export default __webpack_public_path__ + "static/media/picTriNguyen.d8157621.png";